import { CircleXIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { useToast } from "@/hooks/use-toast";

export const useErrorToast = () => {
  const { toast } = useToast();

  return ({ description }: { description: string }) => {
    toast({
      description: (
        <Row className="items-center gap-2">
          <CircleXIcon className="h-6 w-6 fill-red-600 text-white" />
          {description}
        </Row>
      ),
    });
  };
};
